import styled from 'styled-components';
import { Icon } from '../../../../components/common/icon/Icon';

interface InstallmentPossibleSectionProps {
  color?: string;
  backgroundColor?: string;
  boldText?: string;
  text?: string;
}

const defaultColor = '#196EFF';
const defaultBackgroundColor = '#E1FAFF';
const defaultBoldText = '할부가 가능한 매물';
const defaultText = '이예요!';

export const InstallmentPossibleSection = ({
  color = defaultColor,
  backgroundColor = defaultBackgroundColor,
  boldText = defaultBoldText,
  text = defaultText,
}: InstallmentPossibleSectionProps) => {
  return (
    <Container backgroundColor={backgroundColor}>
      <Wrapper>
        <IconTitleContainer>
          <Icon name={'CircleWon'} size={'Large'} fill={color} />
          <TitleContainer>
            <BoldTitle color={color}>{boldText}</BoldTitle>
            <Title color={color}>{text}</Title>
          </TitleContainer>
        </IconTitleContainer>
      </Wrapper>
    </Container>
  );
};

const Container = styled.div<{ backgroundColor: string }>`
  display: flex;
  padding: var(--radius-medium, 8px) var(--radius-large, 16px);
  align-items: center;
  gap: var(--radius-small, 4px);
  align-self: stretch;

  border-radius: var(--radius-none, 0px);
  background: ${(props) => props.backgroundColor};
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
`;

const IconTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--radius-small, 4px);
`;

const TitleContainer = styled.div``;

const Title = styled.span<{ color: string }>`
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  color: ${(props) => props.color};
  text-overflow: ellipsis;

  /* Display/Large/l-medium */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
`;

const BoldTitle = styled(Title)`
  font-weight: 700;
`;
